import { CAARepository } from '../../domain/repositories/CAARepository'
import { CAADatasource } from '../datasources/CAADatasource'

export function caaRepositoryAdapter(
  caaDatasouce: CAADatasource
): CAARepository {
  return {
    async listCAAForOperational(params) {
      return await caaDatasouce.listCAAForOperational(params)
    },

    async listCAAForManagers(params) {
      return await caaDatasouce.listCAAForManagers(params)
    },

    async listDateCAAReport(patientId, date) {
      return await caaDatasouce.listDateCAAReport(patientId, date)
    },
    async listWeekCAAReport(patientId, date) {
      return await caaDatasouce.listWeekCAAReport(patientId, date)
    },
    async listMonthCAAReport(patientId, month, year) {
      return await caaDatasouce.listMonthCAAReport(patientId, month, year)
    },
    async listSemesterCAAReport(patientId, year, semester) {
      return await caaDatasouce.listSemesterCAAReport(patientId, year, semester)
    },
    async listCustomCAAReport(patientId, startDate, endDate) {
      return await caaDatasouce.listCustomCAAReport(
        patientId,
        startDate,
        endDate
      )
    }
  }
}
